<template>
  <div class="prescription-card shadowed-card" @click="viewPrescription">
    <full-screen-loader v-if="loading"/>
    <div class="prescription-card__main flex-row">
      <span class="ns-icon-ico012 ns-x-large-icon" slot="icon"/>
      <div class="m-l-10">
        <p class="Title3">{{ title }}</p>
        <text-string v-if="patientName"
                     class="m-t-10"
                     label-id="txt040"
                     :props="{strings: [patientName, '']}"/>
        <div v-if="prescriptionFile" class="Body3 m-t-5">{{ prescriptionFile.received | displayDateString }}</div>
      </div>
      <smd-spacer/>
      <div class="prescription-card__coupon"
           v-if="showCoupon && !$isMobile">
        <smd-coupon
          :class="{'m-b-20': prescriptionFile.coupons.length > 1 && index !== prescriptionFile.coupons.length - 1}"
          v-for="(coupon, index) in prescriptionFile.coupons"
          :key="index"
          :item="coupon"
          :image="couponLogo"
          :small="true"
          :title="coupon.shortname"/>
      </div>
    </div>

    <div class="flex-center--xy">
      <div class="prescription-card__coupon m-t-15 m-b-5"
           v-if="showCoupon && $isMobile">
        <smd-coupon
          :class="{'m-b-20': prescriptionFile.coupons.length > 1 && index !== prescriptionFile.coupons.length - 1}"
          v-for="(coupon, index) in prescriptionFile.coupons"
          :key="index"
          :item="coupon"
          :image="couponLogo"
          :small="true"
          :title="coupon.shortname"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {
    GETTER_FILES,
  } from '@/store/types';
  import {TitleHeaders} from '@/reference';
  import {formatDate} from '@/utils/dates';
  import {getPrescriptionCoupon} from '@/utils/medicine';
  import {FilesService} from '@/services/files';
  import {mapFields} from "vuex-map-fields";
  import Routes from '@/router/routes';
  import TitleMixin from '@/mixins/title-mixin';
  import ToastMixin from '@/mixins/toast-mixin';
  import {getCouponLogo} from '@/reference/coupon';
  import {
    isFSLEProgramId,
  } from '@/reference/coupon';
  // import ModalPreviewFile from '@/components/preview-file';


  export default {
    name: 'prescription-card',
    mixins: [
      TitleMixin,
      ToastMixin,
    ],
    filters: {
      displayDateString(isoString) {
        return formatDate(isoString, '[Sent on] MMM DD, YYYY [at] h:mm A');
      },
    },
    props: {
      prescription: {type: Object, required: true},
      showCoupon: {type: Boolean, default: false},
    },
    data() {
      return {
        loading: false,
      };
    },
    computed: {
      ...mapFields({
        prescriptionView: 'prescriptionView'
      }),
      ...mapGetters({
        files: GETTER_FILES,
      }),
      prescriptionFile() {
        const presFile = this.files.find(({uploadid}) => uploadid === this.prescription.uploadid);
        const presCoupon = getPrescriptionCoupon(presFile);

        // ndi dapat maattach FSLE coupon, pag normal nspharmacy order
        if (presCoupon && isFSLEProgramId(presCoupon.programid)) {
          return {
            ...presFile,
            coupons: [],
          }
        }

        return presFile;
      },
      isCustom() {
        return this.prescription.source === 'custom';
      },
      title() {
        if (this.isCustom || !this.prescriptionFile) return 'File';

        const fileType = TitleHeaders[this.prescriptionFile.pagetype] || 'File';


        return `${fileType} from ${this.prescriptionFile.doctorname}`;
      },
      patientName() {
        return this.isCustom || !this.prescriptionFile ? null : this.prescriptionFile.patientname;
      },
      couponLogo() {
        const coupon = getPrescriptionCoupon(this.prescriptionFile);
        return getCouponLogo(coupon);
      },
    },
    methods: {
      async viewPrescription() {
        if (!this.prescriptionFile) return;

        // this.loading = true;

        try {
          const {data} = await FilesService.getFileURL(this.prescriptionFile.token, this.prescriptionFile.uploadid);

          if (!data) {
            throw Error();
          }

          this.prescriptionView = this.prescriptionFile;
          // this.loading = false;
          // this.$modal.open({
          //   component: ModalPreviewFile,
          //   props: {
          //     file: data.url,
          //     title: this.computedTitle(this.prescriptionFile),
          //     showButton: false
          //   },
          // });

          await this.$router.push({
            name: Routes.MEDICINE_ORDER_PREVIEW_FILE,
            params: {
              file: [data.url],
              title: this.computedTitle(this.prescriptionFile),
              showButton: false
            }
          })
          // window.open(`${data.url}`, '_blank');
        } catch (e) {
          this.showToast({
            text: 'Failed to view file. Please try again later.',
            theme: 'danger',
          });
          this.loading = false;
        }
      },
    },
  }
</script>

<style lang="scss">
  .prescription-card {
    cursor: pointer;

    &__main {
      @extend %layout--flex-row;
      align-items: center;
    }
  }
</style>
